import React from 'react';
import Header from './Header'
import Content from './Content'
import './App.css'

function App() {
  return (
    <div className="app">
      <Header />
      <Content />
    </div>
  );
}

export default App;
